import { useTenantRealmDropdownsFlow } from 'TenantModule/hooks/useTenantRealmDropdownsFlow';
import { FormEvent, MouseEventHandler, useRef, useState } from 'react';
import { useInitializeSubscriptionRealm } from './useInitializeSubscriptionRealm';

export const useInitializeSubscriptionRealmForm = () => {
  const { onSelectTenantRealm, selectedTenant, onSelectRealm, selectedRealm } =
    useTenantRealmDropdownsFlow();
  const realmDropdownRef = useRef<HTMLDivElement>(null);

  const subscriptionRealmParams = {
    tenant: selectedTenant?.tenantName || '',
    realmId: selectedRealm?.realm_id || '',
  };
  const { isInitializingSubscriptionRealm, initializeSubscriptionRealm } =
    useInitializeSubscriptionRealm();

  const onTenantSelectorClick: MouseEventHandler<HTMLElement> = (e) => {
    if (e.currentTarget && realmDropdownRef.current) {
      onSelectTenantRealm({
        tenantDropdownTarget: e.currentTarget,
        realmDropdownTarget: realmDropdownRef.current,
      });
    }
  };

  const onRealmSelectorClick: MouseEventHandler<HTMLElement> = (e) => {
    if (selectedTenant) {
      onSelectRealm({
        target: e.currentTarget,
        tenantId: selectedTenant.id,
      });
    }
  };

  const onSubmitInitializeSubscriptionRealmForm = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    initializeSubscriptionRealm(subscriptionRealmParams);
  };

  return {
    onTenantSelectorClick,
    onRealmSelectorClick,
    realmDropdownRef,
    selectedRealm,
    selectedTenant,
    isInitializingSubscriptionRealm,
    onSubmitInitializeSubscriptionRealmForm,
  };
};
